import 'aurelia-polyfills';

const cache = {};

function importAll (r) {
  r.keys().forEach(key => cache[key] = r(key));
}

//importAll(require.context('.', true, /spec\.ts$/));
importAll(require.context('.', true, /\.ts$/));
// At build-time cache will be populated with all required modules.
